import {observer} from "mobx-react";
import Scrollable from "../../../components/scrollable/scrollable";

interface IAddItemDrawerLayoutProps {
    drawerBody?: React.ReactNode;
    drawerFooter?: React.ReactNode;
}

const AddItemDrawerLayout : React.FC<IAddItemDrawerLayoutProps> = observer(({drawerBody, drawerFooter})=> {
    return (
        <div className={'drawer-default-layout'}>
            <Scrollable scrollToNewElements={true}>{drawerBody}</Scrollable>
            <div className={'drawer-footer'}>{drawerFooter}</div>
        </div>
    )
});

export default AddItemDrawerLayout;